

export class TemperatureCalibrationOutputWithStatus implements ITemperatureCalibrationOutputWithStatus {
    /** The auto-generated id of the temperature calibration master */
    temperature_calibration_id!: number;
    /** The branch name with 255 character */
    branch!: string;
    /** The auto-generated id of the branch master */
    branch_detail_id!: number;
    /** The company name with 255 character */
    company_name!: string;
    /** The auto-generated id of the company master */
    company_details_id!: number;
    /** The temperature port */
    temperature_port!: string;
    /** The vehicle name and number name with 255 character */
    vehicle!: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id!: number;
    /** The multiplication factor */
    multiplication_factor!: number;
    /** The temperature unit */
    temperature_unit!: number;
    /** Manage status of fuel calibration. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ITemperatureCalibrationOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.temperature_calibration_id = _data["temperature_calibration_id"];
            this.branch = _data["branch"];
            this.branch_detail_id = _data["branch_detail_id"];
            this.company_name = _data["company_name"];
            this.company_details_id = _data["company_details_id"];
            this.temperature_port = _data["temperature_port"];
            this.vehicle = _data["vehicle"];
            this.vehicle_details_id = _data["vehicle_details_id"];
            this.multiplication_factor = _data["multiplication_factor"];
            this.temperature_unit = _data["temperature_unit"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): TemperatureCalibrationOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new TemperatureCalibrationOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["temperature_calibration_id"] = this.temperature_calibration_id;
        data["branch"] = this.branch;
        data["branch_detail_id"] = this.branch_detail_id;
        data["company_name"] = this.company_name;
        data["company_details_id"] = this.company_details_id;
        data["temperature_port"] = this.temperature_port;
        data["vehicle"] = this.vehicle;
        data["vehicle_details_id"] = this.vehicle_details_id;
        data["multiplication_factor"] = this.multiplication_factor;
        data["temperature_unit"] = this.temperature_unit;
        data["status"] = this.status;
        return data; 
    }
}

export interface ITemperatureCalibrationOutputWithStatus {
    /** The auto-generated id of the temperature calibration master */
    temperature_calibration_id: number;
    /** The branch name with 255 character */
    branch: string;
    /** The auto-generated id of the branch master */
    branch_detail_id: number;
    /** The company name with 255 character */
    company_name: string;
    /** The auto-generated id of the company master */
    company_details_id: number;
    /** The temperature port */
    temperature_port: string;
    /** The vehicle name and number name with 255 character */
    vehicle: string;
    /** The auto-generated id of the vehicle details master */
    vehicle_details_id: number;
    /** The multiplication factor */
    multiplication_factor: number;
    /** The temperature unit */
    temperature_unit: number;
    /** Manage status of fuel calibration. 0 For De-active, 1 For Active */
    status: number;
}

